export enum AvatarTypes {
  Beam = 'beam',
  Bauhaus = 'bauhaus',
  Marble = 'marble',
  Pixel = 'pixel',
  Ring = 'ring',
  Sunset = 'sunset'
}
